<template>
  <div ref="modalContainer"></div>
  <a-card class="content-wrapper">
    <template #title>
      <CardHeader></CardHeader>
    </template>
    <div class="body-content">
      <a-form layout="inline">
        <a-form-item label="设备编号">
          <a-input
            v-model:value="params.sn"
            placeholder="输入设备编号"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item label="车场">
          <a-select
            v-model:value="params.parkingLotId"
            notFoundContent="暂无数据"
            style="width: 200px"
            placeholder="请选择"
            allow-clear
            @change="getParkingPlace"
          >
            <a-select-option
              v-for="item in parkingLotList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="泊位编号">
          <a-select
            v-model:value="params.parkingPlaceId"
            notFoundContent="暂无数据"
            style="width: 200px"
            placeholder="请选择"
            allow-clear
          >
            <a-select-option
              v-for="item in parkingPlaceList.list"
              :key="item.id"
              :value="item.id"
              >{{ item.code }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item style="padding-bottom: 10px" label="添加时间">
          <a-range-picker
            style="width: 400px"
            v-model:value="params.createTimeArr"
            :show-time="{ format: 'HH:mm:ss' }"
            format="YYYY-MM-DD HH:mm:ss"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始时间', '结束时间']"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="doQuery">
            <template #icon>
              <SearchOutlined />
            </template>
            查询
          </a-button>
        </a-form-item>
        <a-form-item>
          <a-button class="btn-success" @click="showAddModal">
            <template #icon>
              <PlusCircleOutlined />
            </template>
            添加
          </a-button>
        </a-form-item>
      </a-form>
      <div style="padding: 4px 0">
        <a-table
          row-key="id"
          table-layout="fixed"
          :data-source="dataList.list"
          :columns="columns"
          :loading="loading"
          :pagination="false"
          :scroll="{ y: 500 }"
          bordered
        >
          <template #operation="{ record }">
            <div>
              <TipButton
                perm="parking:billRule:edit"
                btn-class="btn-success"
                title="编辑"
                @btnClick="showEditModal(record.id)"
              >
                <template #default>
                  <EditOutlined />
                </template>
              </TipButton>
              <TipButton
                perm="parking:billRule:del"
                btn-class="btn-danger"
                title="删除"
                @btnClick="delItem(record.id)"
              >
                <template #default>
                  <DeleteOutlined />
                </template>
              </TipButton>
            </div>
          </template>
        </a-table>
      </div>
      <a-pagination
        v-model:current="page"
        v-model:page-size="pageSize"
        :total="total"
        :show-total="total => `${total}条数据`"
        @change="currentChange"
      >
      </a-pagination>
    </div>
  </a-card>
  <add
    v-if="addShow"
    :modal-ref="$refs.modalContainer"
    @close="hideAddModal"
  ></add>
  <edit
    v-if="editShow"
    :id="currentId"
    :modal-ref="$refs.modalContainer"
    @close="hideEditModal"
  ></edit>
</template>

<script>
import CardHeader from "@/components/CardHeader";
import useGeomagnetic from "@/hooks/maintenance/useGeomagnetic";
import usePagination from "@/hooks/usePagination";
import useAddExit from "@/hooks/useAddExit";
import { onMounted, reactive } from "vue";
import Add from "@/views/Maintenance/Geomagnetic/components/Add";
import Edit from "@/views/Maintenance/Geomagnetic/components/Edit";
import useMessage from "@/hooks/useMessage";
import { deleteGeomagnetic } from "@/api/maintenance/geomagneticApi";
import TipButton from "@/components/TipButton";
import { listAll } from "../../../api/parking/parkingPlaceApi";

export default {
  name: "index",
  components: {
    Edit,
    Add,
    CardHeader,
    TipButton,
  },
  setup() {
    const {
      params,
      dataList,
      total,
      loading,
      columns,
      parkingLotList,
      loadData,
      getParkingLotList,
    } = useGeomagnetic();

    const { page, pageSize, currentChange, doQuery, doRefresh } =
      usePagination(loadData);

    const {
      currentId,
      addShow,
      editShow,
      showAddModal,
      showEditModal,
      hideAddModal,
      hideEditModal,
    } = useAddExit(doQuery);

    const { showConfirm, showLoading, closeLoading, showTipMessage, showErr } =
      useMessage();

    const parkingPlaceList = reactive({ list: [] });

    onMounted(async () => {
      getParkingLotList();
      loadData(page.value, pageSize.value);
    });

    const getParkingPlace = async parkingLotId => {
      if (parkingLotId == null) {
        parkingPlaceList.list = []
        params.parkingPlaceId = null
        return ;
      }
      try {
        let { data } = await listAll(parkingLotId);
        parkingPlaceList.list = data;
      } catch (e) {
        showErr(e);
      }
    };

    const delItem = async id => {
      let action = await showConfirm("是否删除地磁设备?");
      if (action) {
        await showLoading("正在删除，请稍后...");
        try {
          await deleteGeomagnetic(id);
          await closeLoading();
          await showTipMessage("删除成功", "success");
          doQuery();
        } catch (e) {
          await closeLoading();
          await showErr(e);
        }
      }
    };

    return {
      parkingLotList,
      parkingPlaceList,
      getParkingPlace,
      params,
      page,
      pageSize,
      total,
      loading,
      currentChange,
      dataList,
      doQuery,
      doRefresh,
      columns,

      currentId,
      addShow,
      editShow,
      showEditModal,
      showAddModal,
      hideAddModal,
      hideEditModal,
      delItem,
    };
  },
};
</script>

<style scoped></style>
